import { convertAmountToCurrency } from "@/utils/trade";
import { ISymbolInfo } from "@/services/trade/symbols";

type OperationType = "Buy" | "Sell";

interface CalculatePointAndPipValueParams {
    point: number;
    lotValue: string | number;
    isForex: boolean;
    operationType: OperationType;
    bid: number;
    ask: number;
    symbolInfo: ISymbolInfo;
    accountCurrency: string;
    symbols: string[];
    mainCurrency: string;
    isMTR: boolean;
}

interface CalculatePointAndPipValueResult {
    pointValue: number;
    pipValue: number;
}

export function calculatePointAndPipValue({
    point,
    lotValue,
    isForex,
    operationType,
    bid,
    ask,
    symbolInfo,
    accountCurrency,
    symbols,
    mainCurrency,
    isMTR,
}: CalculatePointAndPipValueParams): CalculatePointAndPipValueResult {

    const basePrice = isForex ? 1 : (operationType === "Sell" ? bid : ask);
    const amount = (point * Number(lotValue)) / basePrice;

    const converted = convertAmountToCurrency({
        amount,
        fromCurrency: isMTR ? symbolInfo?.ex?.quoteCurrency : mainCurrency,
        toCurrency: accountCurrency,
        symbols,
        conversionPriceType: "Bid"
    });

    return {
        pointValue: converted,
        pipValue: converted * 10
    };
}